import ElInput from './src/input';

/* istanbul ignore next */
ElInput.install = function (Vue) {
  Vue.component(ElInput.name, ElInput);
};

export default ElInput;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/element-ui/packages/input/index.js